import React, { useState, useEffect } from "react";
import Header from "../../shared/header/Header";
import Footer from "../../shared/footer/Footer";
import { Outlet } from "react-router-dom";
import axiosInstance from "../../axios/axiosInstance";
import { useUser } from "../../contexts/UserContext";
const Root = ({ globalData }) => {
  console.log("🚀 ~ Root ~ globalData:", globalData)
  const { user } = useUser();
  const [userProfile, setUserProfile] = useState(null);
  // get user profile via /user/profile
  const getUserProfile = async () => {
    if (user?.user_type === "admin") return;
    try {
      const response = await axiosInstance.get("/user/profile", {});
      setUserProfile(response.data.data);
    } catch (error) {
      console.log("🚀 ~ getUserProfile ~ error:", error);
    }
  };

  useEffect(() => {
    if (user) {
      getUserProfile();
    }
  }, [user]);

  return (
    <>
      <Header picture={userProfile?.picture} />
      <div className="pt-[100px]">
        <Outlet context={{ globalData, userProfile }} />
      </div>
      <Footer map_link={globalData?.map_link} />
    </>
  );
};

export default Root;
